export default "//file.bilionpass.com/japandx-portal/0.1.17/static/img/example-tour-layer-2.63e606f2-8b5933.png";